import { BaseModal } from './baseModal'
import { createSelectors } from '../utils/selectorUtils';
import { createLogger } from '../utils/debugLogger';
const l = createLogger('ModalDestination.js');

export class ModalDestination extends BaseModal {
    static Selectors = createSelectors({
        INPUT: {
            SELECTED: `data-ts-cb-destination`
        }
    });

    static Config = {
        QUERY_STRING_KEY: 'filterdestinations'
    }

    // Now we have to use the factory method
    static createModal(queryStringManager) {
        return BaseModal.create.call(this, 'ModalDestination', queryStringManager);
    }
}
